export interface Faq {
  question: string;
  answer: string;
  src?: string;
  //   index: string | null;
  //   isExpanded: string | null;
  //
}

export const faqItems: Faq[] = [
  {
    question: 'faqs.faq1.question',
    answer: 'faqs.faq1.answer',
    // src: '/assets/images/africaMap.png',
  },
  {
    question: 'faqs.faq2.question',
    answer: 'faqs.faq2.answer',
  },
  {
    question: 'faqs.faq3.question',
    answer: 'faqs.faq3.answer',
  },
];
